if (!customElements.get('wlsn-key-benefits')) {
    class WLSNKeyBenefits extends HTMLElement {
      constructor() {
        super();
  
        this.classes = {
          number: 'js-wlsn-key-benefits-number',
        };
  
        this.elements = {
          numbers: this.querySelectorAll(`.${this.classes.number}`),
        };
      }
  
      connectedCallback() {
        if (!this.elements.numbers.length) return;
        this.initObserver();
      }
  
      initObserver() {
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.animateNumbers();
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.6 }
        );
  
        this.observer.observe(this);
      }
  
      animateNumbers() {
        this.elements.numbers.forEach(el => {
          if (el.classList.contains('is-animated')) return;
          el.classList.add('is-animated');
  
          const rawValue = el.dataset.number;
          const target = parseFloat(rawValue);
          if (isNaN(target)) return;
  
          const decimals = (rawValue.split('.')[1] || '').length;
          const duration = target < 1 ? 800 : 1500;
          const start = performance.now();
  
          const animate = (now) => {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            const value = eased * target;
  
            el.textContent = value.toFixed(decimals);
  
            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              el.textContent = target.toFixed(decimals);
            }
          };
  
          requestAnimationFrame(animate);
        });
      }
    }
  
    customElements.define('wlsn-key-benefits', WLSNKeyBenefits);
  }
  